<div *ngIf="show"
     class="mat-snack-bar-container ui-persistent-notification">
    <div class="ui-persistent-notification-message">{{ message }}</div>
    <div class="ui-persistent-notification-actions">
        <button (click)="confirm()"
                color="primary"
                mat-button
                type="button">{{ buttonLabel }}</button>
        <button [matTooltip]="'ui_persistent_close' | translate"
                (click)="dismiss()"
                mat-icon-button
                type="button">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>
